import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/UI/Hero';
import Button from '../components/UI/Button';
import ImageShowcase from '../components/UI/ImageShowcase';
import Gallery from '../components/UI/Gallery';
import { getProductById } from '../data/products';
import backgroundVideo from '../assets/optimized/background-optimized.mp4';
import videoPoster from '../assets/optimized/poster.webp';
import asset1 from '../assets/optimized/asset1.webp';
import asset2 from '../assets/optimized/asset2.webp';
import asset3 from '../assets/optimized/asset3.webp';
import asset4 from '../assets/optimized/asset4.webp';
import asset5 from '../assets/optimized/asset5.webp';
import asset6 from '../assets/optimized/asset6.webp';
import asset7 from '../assets/optimized/asset7.webp';
import asset8 from '../assets/optimized/asset8.webp';
import asset9 from '../assets/optimized/asset9.webp';
import asset10 from '../assets/optimized/asset10.webp';
import asset11 from '../assets/optimized/asset11.webp';
import asset12 from '../assets/optimized/asset12.webp';
import wopr2 from '../assets/projects/wopr2.webp';
import idleveil1 from '../assets/projects/idleveil1.webp';
import './HomePage.css';

const HomePage = () => {
  const mandatum = getProductById('mandatum');

  const galleryImages = [
    asset1, asset2, asset3, asset4, asset5, asset6,
    asset7, asset8, asset9, asset10, asset11, asset12
  ];

  return (
    <div className="home-page">
      <Hero
        video={backgroundVideo}
        poster={videoPoster}
        label="Software & Aerial Production"
        title="AeroCapture Productions"
        subtitle="We build software solutions and capture stunning aerial footage"
      >
        <Button to="/products" variant="primary" size="large">
          Explore Products
        </Button>
        <Button to="/projects" variant="outline" size="large">
          View Our Work
        </Button>
      </Hero>

      <section className="intro-section">
        <div className="container">
          <div className="intro-content text-center">
            <h2 className="section-title">Crafting Digital Experiences</h2>
            <p className="section-subtitle">
              From intuitive desktop applications to breathtaking aerial photography,
              we bring ideas to life with precision and creativity.
            </p>
          </div>
        </div>
      </section>

      <ImageShowcase
        image={asset3}
        label="Aerial Photography"
        title="Perspectives That Inspire"
        description="Our drone photography captures landscapes and moments from angles that reveal the extraordinary in everyday scenes."
        link="#aerial-gallery"
        linkText="View Gallery"
      />

      {mandatum && (
        <ImageShowcase
          image={mandatum.image}
          label="Featured Product"
          title={mandatum.name}
          description="A prompt engineering SaaS platform combining prompt management with custom code execution."
          link="/products/mandatum"
          linkText="Learn More"
          reverse
        />
      )}

      <section id="aerial-gallery" className="gallery-section">
        <div className="container">
          <div className="gallery-header text-center">
            <span className="section-label">Our Work</span>
            <h2 className="section-title">Aerial Portfolio</h2>
            <p className="section-subtitle">
              A collection of aerial captures showcasing unique perspectives and landscapes.
            </p>
          </div>
        </div>
        <Gallery images={galleryImages} />
      </section>

      <section className="feature-grid-section">
        <div className="container">
          <div className="feature-grid">
            <Link to="/products/wopr" className="feature-card feature-card-large">
              <img src={wopr2} alt="WOPR Desktop Application" />
              <div className="feature-card-content">
                <span className="feature-card-label">Software</span>
                <h3 className="feature-card-title">Desktop Applications</h3>
                <p className="feature-card-desc">Native apps for macOS, Windows, and Linux</p>
              </div>
            </Link>
            <Link to="/products/idleveil" className="feature-card">
              <img src={idleveil1} alt="Idleveil Web Application" />
              <div className="feature-card-content">
                <span className="feature-card-label">Web</span>
                <h3 className="feature-card-title">Web Development</h3>
              </div>
            </Link>
            <Link to="/projects" className="feature-card">
              <img src={asset11} alt="Drone Services" />
              <div className="feature-card-content">
                <span className="feature-card-label">Aerial</span>
                <h3 className="feature-card-title">Drone Photography</h3>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-background">
          <img src={asset6} alt="" />
        </div>
        <div className="cta-overlay" />
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Have a Project in Mind?</h2>
            <p className="cta-desc">
              Let's discuss how we can help bring your ideas to life.
            </p>
            <Button to="/contact" variant="primary" size="large">
              Get in Touch
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
